import { useCallback } from 'react';
import { queryCache, useQuery } from 'react-query';
var QUERY_KEY = 'ShowCopilotTUI';
export var useShowCopilotTUI = function () {
    var _a = useQuery(QUERY_KEY, {
        initialData: undefined,
    }), showCopilotTUI = _a.data, refetch = _a.refetch;
    var updateShowCopilotTUI = useCallback(function (newData) {
        queryCache.setQueryData(QUERY_KEY, newData);
    }, []);
    return { showCopilotTUI: showCopilotTUI, updateShowCopilotTUI: updateShowCopilotTUI, refetch: refetch };
};
//# sourceMappingURL=useShowCopilotTUI.js.map